const dateFormatter = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
})

const dateTimeFormatter = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
})

export function formatCivilDate(value: string) {
  return dateFormatter.format(new Date(`${value}T12:00:00`))
}

export function formatDateTime(value: string) {
  return dateTimeFormatter.format(new Date(value))
}

export function formatBytes(value: number) {
  if (!Number.isFinite(value) || value <= 0) return '0 MB'
  const megabytes = value / (1024 * 1024)
  if (megabytes < 1024) return `${megabytes.toFixed(megabytes >= 10 ? 0 : 1)} MB`
  return `${(megabytes / 1024).toFixed(1)} GB`
}
